import { leaseGateway } from '~/gateways/leaseGateway';
import { LeaseStatus } from '~/types/LeaseStatus';
import { MagicUseCase } from './magicUseCase';

const DEACTIVATED_STATUS = [LeaseStatus.Ended];

export class GetLeasesUseCase extends MagicUseCase {
  protected async runLogic() {
    const leases = await leaseGateway.getLeases();
    this.getState().user.leases = leases;
    this.getState().user.deactivatedLeases = leases.filter((lease) => DEACTIVATED_STATUS.includes(lease.status as LeaseStatus));
    const selectedLease = leases.find((lease) => lease.id === this.getState().user.selectedLease?.id);
    if (selectedLease) {
      this.getState().user.selectedLease = selectedLease;
    } else {
      this.getState().user.selectedLease = leases[0];
    }
  }
}
